import { client } from '../client';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export interface ITags {
  id: number;
  description: string;
  patient_owned: boolean;
  name: string;
  value?: string;
}

export const getMyTags = async (dependent_id?: number, userRole?: string): Promise<ITags[]> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  let endpoint = `${prefix}/tags/me`;
  if (dependent_id && dependent_id !== undefined) {
    endpoint += `?dependent_id=${dependent_id}`;
  }

  const { data } = await client.get(endpoint);

  return data;
};
